import axios from "axios";
import JobTransactionsModel from "./JobTransactionsModel";


export default class JobTransactionsCommand{
      jobTransactions : JobTransactionsModel[];
      totalPages: number;
      totalCount : number;

      constructor()
      {
        this.jobTransactions=[];
        this.totalPages=0;
        this.totalCount=0;
      }

      async loadJobTransactions(pageNumber: number, pageSize: number, jobid:any, status:any , filterid:any) {
        try {
            const API_URL = process.env.REACT_APP_API_URL
            const idToken : string | null = localStorage.getItem("IdToken");
            const response = await axios.get(`${API_URL}/v1/jobs/${jobid}/transactions`, {
                params: {
                    page: pageNumber,
                    pageSize: pageSize,
                    status : status,
                    filterid:filterid
                },
                headers:{
                    'Authorization': `${idToken}`
                }
            });

            const data = response.data.response.items;
            this.jobTransactions = data;
            this.totalPages = response.data.response.totalPages
            this.totalCount=response.data.response.totalCount
        } catch (error) {
            console.error('Failed to load job transactions data:', error);
        }
    }
}